import { render, staticRenderFns } from "./ReportsSentEstimatesEstimates.vue?vue&type=template&id=71560e7b&"
import script from "./ReportsSentEstimatesEstimates.vue?vue&type=script&lang=js&"
export * from "./ReportsSentEstimatesEstimates.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports